/**
 * The store's brand list on the client (D39). Pure helpers, tested.
 */
const slug = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const typesOf = (b) => {
  if (Array.isArray(b.product_types)) return b.product_types;
  try {
    const a = JSON.parse(b.product_types || '[]');
    return Array.isArray(a) ? a : [];
  } catch {
    return [];
  }
};

/**
 * Select options for active brands: brands tagged with `typeKey` first, then the
 * rest, each group A–Z. `keepId` stays listed even if turned off (an existing model's brand).
 */
export function brandOptions(brands, typeKey, keepId = null) {
  const rows = (brands || []).filter((b) => Number(b.is_active) !== 0 || (keepId != null && String(b.id) === String(keepId)));
  const rank = (b) => (typeKey && typesOf(b).includes(typeKey) ? 0 : 1);
  return rows
    .slice()
    .sort((a, b) => rank(a) - rank(b) || a.name.localeCompare(b.name))
    .map((b) => ({ value: String(b.id), label: Number(b.is_active) === 0 ? `${b.name} (turned off)` : b.name }));
}

/** The brand with this name by slug, as the server matches: "DELL" = "Dell", "One Plus" = "one-plus". */
export function findBrandByName(brands, name) {
  const s = slug(name);
  return s ? (brands || []).find((b) => (b.slug || slug(b.name)) === s) || null : null;
}

export { typesOf as brandTypes };
